import config from '@/config'
import { profileSelector } from '@/selectors'

const LOAD_INTERCOM = 'LOAD_INTERCOM'
const UNLOAD_INTERCOM = 'UNLOAD_INTERCOM'
const UPDATE_INTERCOM_PROFILE = 'UPDATE_INTERCOM_PROFILE'
const TRACK_INTERCOM_EVENT = 'TRACK_INTERCOM_EVENT'
const UPDATE_INTERCOM = 'UPDATE_INTERCOM'
const SHOW_INTERCOM = 'SHOW_INTERCOM'
const SHOW_INTERCOM_NEW_MESSAGE = 'SHOW_INTERCOM_NEW_MESSAGE'

export const loadIntercom = () => (dispatch) => {
    dispatch({ type: LOAD_INTERCOM })

    if (typeof window.Intercom === 'function') {
        window.Intercom('boot', {
            app_id: config.intercomAppId,
        })
    }
}

export const unloadIntercom = () => (dispatch) => {
    dispatch({ type: UNLOAD_INTERCOM })

    if (typeof window.Intercom === 'function') {
        window.Intercom('shutdown')
    }
}

export const trackIntercomEvent = (data) => (dispatch) => {
    dispatch({ type: TRACK_INTERCOM_EVENT, data })

    if (typeof window.Intercom === 'function') {
        window.Intercom('trackEvent', data)
    }
}

export const updateIntercom = (intercomSettings) => (dispatch) => {
    dispatch({ type: UPDATE_INTERCOM })

    if (typeof window.Intercom === 'function') {
        window.Intercom('update', intercomSettings)
    }
}

export const updateIntercomProfile =
    (data = {}) =>
    (dispatch, getState) => {
        const profile = profileSelector(getState())

        const {
            accountantFullName,
            email,
            emailMarketingConsent,
            firstName,
            hmacToken,
            id: userId,
            isSelfEmployed,
            isCompany,
            isNewCompany,
            isNewSelfEmployed,
            lastName,
            phoneNumber,
            referralSchemeCode,
            referralSource,
            selfDeclaredAttributionSource,
            subscriptionStatus,
            taxRegistrationStatus,
            variant,
            languagePreference,
        } = profile

        const name = firstName || lastName ? `${firstName} ${lastName}`.trim() : null

        const userData = {
            accountant_name: accountantFullName || null,
            email,
            is_self_employed: isSelfEmployed,
            is_company: isCompany,
            is_new_company: isNewCompany,
            is_new_self_employed: isNewSelfEmployed,
            language_preference: languagePreference,
            marketing_consent: emailMarketingConsent,
            name,
            phone: phoneNumber,
            referral_scheme_code: referralSchemeCode,
            referral_source: referralSource,
            self_declared_attribution: selfDeclaredAttributionSource,
            subscription_status: subscriptionStatus,
            tax_registration_status: taxRegistrationStatus,
            user_hash: hmacToken,
            user_id: userId,
            user_link: `${config.accountantPortalUrl}customers/${userId}`,
            variant,
            ...data,
        }

        dispatch({ type: UPDATE_INTERCOM_PROFILE, userData })

        if (typeof window.Intercom === 'function') {
            window.Intercom('update', userData)
        }
    }

export const showIntercom = () => (dispatch) => {
    dispatch({ type: SHOW_INTERCOM })

    if (typeof window.Intercom === 'function') {
        window.Intercom('show')
    }
}

export const showIntercomLauncher = () => (dispatch) => {
    dispatch(updateIntercom({ hide_default_launcher: false }))
}

export const hideIntercomLauncher = () => (dispatch) => {
    dispatch(updateIntercom({ hide_default_launcher: true }))
}

export const showIntercomNewMessage =
    (givenMessage = '') =>
    (dispatch) => {
        dispatch({ type: SHOW_INTERCOM_NEW_MESSAGE })

        if (typeof window.Intercom === 'function') {
            if (givenMessage) {
                window.Intercom('showNewMessage', givenMessage)
            } else {
                window.Intercom('showNewMessage')
            }
        }
    }
